<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				<span v-if="subject!=null" class="red">
					{{subject.SubjectTitle +' '+ subject.SubjectName}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					{{subject.BeginDateTime+'~'+subject.EndDateTime}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					{{subject.ShopName}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					{{subject.Count+'/'+subject.ChildCount +'人'}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					{{subject.state}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					<img v-if="subject.Subjectimg!=undefined" :src="$store.state.baseURL.replace('/api','')+'subjectImg/' +subject.Subjectimg" />
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div  v-if="subject!=null"  style="padding-top: 1rem;">
				<p  >
					<input type="text" placeholder="会员手机号|扫描会员二维码" @keypress.enter="getCustomer()" class="search"
						v-model="customerCode" />
					<button type="button" :class="{'disabled':subject.isEnd}" class="button"
						:disabled="customerCode.length<11 || subject.isEnd" @click="getCustomer()"
						title="点击进行查找">查询用户</button>
				</p>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>手机号</th>
							<td>
								会员姓名
							</td>
							<th>应付金额</th>
							<th>已付金额</th>
							<th  v-if="subject.PayMoney>0">缴费</th>
							<td>取消报名</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in subjectCustomer">
							<td>{{index+1}}</td>
							<td>
								{{i.CustomerPhone}}
							</td>
							<td>
								{{i.CustomerName}}
							</td>
							<td>
								{{i.PayMoney | rmb}}
							</td>
							<td>
								{{i.Disbursements | rmb}}
							</td>
							<td v-if="subject.PayMoney>0">
								<input  style="width: 4rem;" type="text" v-model="i.inputMoney" />
								<button  @click="payMoney(i)"  type="button" class="button" :class="{'disabled':(i.inputMoney*1 +i.Disbursements*1>i.PayMoney && i.inputMoney>0) || i.inputMoney==0 || (0-i.Disbursements<i.inputMoney && i.inputMoney<0)}" 
									:disabled="(i.inputMoney*1 +i.Disbursements*1>i.PayMoney && i.inputMoney>0) || i.inputMoney==0 || (0-i.Disbursements<i.inputMoney && i.inputMoney<0)">{{i.inputMoney>=0?'缴费':'退费'}}</button>			 
							</td>
							<td>
								<button type="button" @click='cancleSingUp(i)' class="button">取消报名</button>
							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>

	</div>
</template>

<script>
	import j from './shopSubjectSignUpDetail.js'
	export default j
</script>

<style scoped>
	.content_head p {
		padding: .2rem;
	}

	.content_head img {
		width: 15rem;
		height: auto;
		vertical-align: middle;
	}
</style>
